import { IShareType } from "../interfaces/share-type.interface";

export const SHARE_TYPES: Array<IShareType> = [
  { id: 1, code: 'LBN', label: 'LBN' },
  { id: 2, code: 'GBN', label: 'GBN' },
  { id: 3, code: 'UBN', label: 'UBN' },
  { id: 4, code: 'NBO', label: 'NBO' },
  { id: 5, code: 'GBO', label: 'GBO' },
];